export const INCLUDE_FALLBACK_DEFAULT_VALUE = false;
//# sourceMappingURL=fallback.js.map